import React from 'react';
import { useNavigate } from 'react-router-dom';
import useTranslation from '../hooks/useTranslation';

interface BackHeaderProps {
  title?: string;
  useTranslation?: boolean;
}

const BackHeader: React.FC<BackHeaderProps> = ({ title, useTranslation: shouldUseTranslation = false }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleGoBack = () => {
    // 뒤로 가기가 가능한지 확인 (히스토리 길이로 판단)
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      // 별도 링크로 직접 접근한 경우 홈으로 이동
      navigate('/', { replace: true });
    }
  };

  // 제목 결정 로직
  const getDisplayTitle = () => {
    if (title) {
      return shouldUseTranslation ? t(title) : title;
    }
    // 기본값으로 'nav.guides' 번역 키 사용
    return t('nav.guides');
  };

  const displayTitle = getDisplayTitle();

  return (
    <header className="md-app-bar border-b md-outline sticky top-0 z-[9999]">
      <div className="md-spacing-1 flex justify-between items-center">
        <div className="flex items-center flex-1 min-w-0">
          <button 
            onClick={handleGoBack}
            className="flex-shrink-0 flex items-center justify-center min-h-[48px] min-w-[48px] rounded-full hover:bg-gray-100 transition-colors"
            aria-label="Go back"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 md-on-surface">
              <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
            </svg>
          </button>
          <h1 className="md-title-small md-on-surface ml-2 truncate max-w-[calc(100%-120px)]" title={displayTitle}>{displayTitle}</h1>
        </div>
        <div className="flex-shrink-0 ml-2">
          {/* 언어 선택 UI */}
          <div className="flex items-center">
            {/* 언어 선택 토글 제거됨 */}
          </div>
        </div>
      </div>
    </header>
  );
};

export default BackHeader; 